import React, { useContext } from "react";
import { InvestCardComponent } from "./InvestCardComponent";
import { InvestFormContext } from "./contexts/InvestFormContext";
import { InvestCalculationContext } from "./contexts/InvestCalculationContext";
import { InvestTransactionContext } from "./contexts/InvestTransactionContext";
import { Stack, TextField, Typography,Button,Box, InputAdornment } from "@mui/material";
import { convertToIndianFormat } from "../../../../utils/functions";
import CustomIcon from "../../../../components/customIcon";

export const AmountCard = React.memo(() => {
    const { amount, setAmount, calculateAmount, editable } = useContext(InvestFormContext);
    const { minAmount, maxAmount } = useContext(InvestCalculationContext);
    const { transaction } = useContext(InvestTransactionContext);
    // const []
    return (
        <InvestCardComponent title={`${!transaction ? "Enter" : ""} Investment Amount`} info={false}>

            <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                <Typography variant="body2" sx={{ fontFamily: "Roboto", fontWeight: 300, mb: 1 }}> Start Investment  from  &nbsp;
                    <Typography variant="body3" sx={{ fontFamily: "Roboto", display: "inline-block", fontWeight: 900, fontStyle: "italic" }}>{convertToIndianFormat(minAmount)}</Typography>
                    &nbsp;  up to &nbsp;
                    <Typography variant="body3" sx={{ fontFamily: "Roboto", display: "inline-block", fontWeight: 900, fontStyle: "italic" }}>{convertToIndianFormat(maxAmount)}</Typography>

                </Typography>


                {/* <Typography variant="body2" sx={{fontFamily:"Roboto",fontWeight:300,mb:1}}>Min Investment: 
            <Typography variant="body2" sx={{fontFamily:"Roboto",display:"inline-block",fontWeight:900,fontStyle:"italic"}}>₹ {convertToIndianFormat(minAmount)}</Typography>
            </Typography> */}

            </Stack>


            <TextField
                disabled={transaction}
                autoComplete="off"
                inputProps={{
                    readOnly: !editable,
                    style: {
                        fontSize: "22px",
                        padding: "12px 16px",
                        fontWeight: "600",
                    }
                }}
                value={amount}
                onChange={(e) => {
                    const inputValue = e.target.value;
                    if (RegExp('^[0-9]*$').test(inputValue)) {
                        setAmount(inputValue);
                    }
                }}
                InputProps={{
                    sx: {
                        padding: "0px !important"
                    },


                    startAdornment: <InputAdornment position="start">
                        <Typography variant="h4" sx={{ fontFamily: "Roboto", color: "#9F9F9F", fontWeight: 400, ml: 3 }}>
                            ₹
                        </Typography>
                    </InputAdornment>,
                    endAdornment: !transaction && <InputAdornment sx={{ ml: 0 }} position="end">
                        <Button onClick={calculateAmount}
                            disabled={editable && !(parseInt(minAmount) <= parseInt(amount) && parseInt(amount) <= parseInt(maxAmount))}
                            fullWidth variant={editable ? "contained" : "text"} color="secondary">
                            {editable ? "Proceed" : "Edit"}
                        </Button>
                    </InputAdornment>

                }}
            >

            </TextField>
            <Box mt={"16px"}>

                <Stack direction={"row"} alignItems={{ md: "center", xs: "flex-start" }} spacing={1} sx={{
                    px: 1.5,
                    py: 0.5,
                    bgcolor: "warning.light",
                    width: { md: "max-content", xs: "100%" },
                    borderRadius: 0.5,
                }}>
                    <CustomIcon name="important" sx={{ width: 12, bgcolor: "warning.main" }} />
                    <Typography variant="body2" sx={{ fontFamily: "Roboto", fontWeight: 400, color: "warning.dark", fontStyle: "italic" }}>
                        Investment amount will be automatically adjusted to closest multiple value
                    </Typography>
                </Stack>
            </Box>
        </InvestCardComponent>
    )
})